<script setup lang="ts"></script>

<template>
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 4L5 7L8 4" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
